import Dashboard from "../dashboard/Dashboard";

import MultiuserLocationTracking from "../../common/MultiuserLocationTracking";
import MapComponent from "../map/MapComponent";
import TeamRegistration from "../Master/Teams";
import UserRegistration from "../Master/User_Registration";
import PicklistPage from "../../modules/Master/Picklist";
import Stakeholder from "../Master/Stakeholders";
import StakeholderHeader from "../Master/Stakeholders/components/StakeholderHeader";
import CreateNewCase from "../Case_Management/Case_Information";
import SearchCase from "../Case_Management/Case_Search/components/SearchCaseList";
import AdvanceSearchCase from "../Case_Management/Case_Search/components/AdvanceSearchList";
import AccountVerification from "../login/AccountVerification";
import UpdatePassword from "../login/UpdatePassword";
import { updateAuthForm } from "../../redux/slice/loginSlice";
import DoctorScedule from "../doctorScedule/manageScedule";
import ViewQMESchedule from "../Case_Management/CaseQME_Schedule/components/View_QME_Schedule";
import ShareRecords from "../ShareRecords";
import Appointments from "../Appointments";
import AssociatedLocationsMapForQMESchedule from "../Case_Management/CaseQME_Schedule/components/QMEScheduleLocationMap";
import SystemLocationList from "../Master/Location";
import DoctorAppointmentMapLayout from "../Appointments/components/DoctorAppointmentMapLayout";
import NotificationConfigurationMaster from "../Configuration/Notification-Preference";
import ToDos from "../ToDos";
import { BillingDashboard } from "../Master/Billing";
import Invoice from "../Invoice/ManageInvoice";
import InvoiceReportDashboard from "../Invoice/Invoice Reports";

const Routes = [
  {
    path: "/",
    exact: true,
    name: "Dashboard",
    component: Dashboard,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Dashboard",
  },

  {
    path: "/multiUser-location-tracking",
    name: "Map",
    component: MultiuserLocationTracking,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
  },
  {
    path: "/map-component",
    name: "Map",
    component: MapComponent,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
  },
  {
    path: "/picklist",
    name: "Picklist",
    component: PicklistPage,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Admin \\ Picklist Management",
  },

  {
    path: "/add-Teams",
    name: "Teams",
    component: TeamRegistration,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Admin \\ Team Management",
  },
  {
    path: "/billing-configuration",
    name: "Billing Configuration",
    component: BillingDashboard,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Admin \\ Billing Configuration",
  },
  {
    path: "/user-registration",
    name: "User Management",
    component: UserRegistration,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Admin \\ User Registration",
  },
  {
    path: "/parties",
    name: "Parties",
    component: Stakeholder,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Admin \\ Stakeholder Management",
  },
  {
    path: "/notification-preference",
    name: "Notification Preference",
    component: NotificationConfigurationMaster,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Admin \\ Configuration",
  },
  {
    path: "/location",
    name: "location",
    component: SystemLocationList,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Admin \\ Location",
  },
  {
    path: "/create-case",
    name: "Create Case",
    component: CreateNewCase,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Create Case",
  },

  {
    path: "/search-case",
    name: "Search Case",
    component: SearchCase,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Search Case",
  },
  {
    path: "/search-case/view_qme_schedule",
    name: "View QME Schedule",
    component: ViewQMESchedule,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Search Case",
  },
  {
    path: "/advancesearch-case",
    name: "Advance Search Case",
    component: AdvanceSearchCase,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Search Case",
  },
  {
    path: "/account-verification/:token?",
    name: "AccountVerification",
    component: AccountVerification,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
  },
  {
    path: "/updatePassword/:token?",
    name: "UpdatePassword",
    component: UpdatePassword,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
  },
  {
    name: "QME Profile",
    path: "/profile",
    component: DoctorScedule,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "QME Profile",
  },
  {
    name: "Share Records",
    path: "/shareRecords",
    component: ShareRecords,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Share Records",
  },
  {
    name: "Appointments",
    path: "/appointment",
    component: Appointments,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Appointment",
  },
  {
    name: "My ToDo",
    path: "/mytodos",
    component: ToDos,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "My ToDo",
  },
  {
    path: "/map/associated_locations",
    name: "Associated Location Map",
    component: AssociatedLocationsMapForQMESchedule,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Search Case",
  },
  {
    path: "/appointment/map",
    name: "Appointment Map",
    component: DoctorAppointmentMapLayout,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Appointment",
  },
  {
    path: "/manage-invoice",
    name: "Manage Invoice",
    component: Invoice,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Invoice \\ Manage Invoice",
  },
  {
    path: "/invoice-reports",
    name: "Invoice Reports",
    component: InvoiceReportDashboard,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "Invoice \\ Invoice Reports",
  },
  {
    path: "/mytodos-view-invoice",
    name: "View Invoice",
    component: Invoice,
    exact: true,
    groupName: "",
    moduleName: "",
    byPass: true,
    feature: "My ToDo",
  },
];

export default Routes;
